<nz-tabset [nzDestroyInactiveTabPane]="true">
  <nz-tab nzTitle="Users">
    <ng-template nz-tab>
      <nz-card>
        <div nz-row class="button-wrapper" *ngIf="authService.hasEntitlements(createUserModule)">
          <button nz-button nzType="primary" nzSize="large" (click)="openCreateUserModal()">
            <span nz-icon nzType="plus"></span>
            Add User
          </button>
        </div>
        <div nz-col class="user-list" nzSpan="24">
          <app-list-users></app-list-users>
        </div>
      </nz-card>
    </ng-template>
  </nz-tab>
</nz-tabset>
